<template>
  <div class="boix">
    <!-- element-ui -->
    <el-container>
      <el-header height='.9rem'>
        <div class="header">
          <!-- <img style="height: 80px" class="bg" src="" alt=""> -->
          <div class="header-left">
            <div class="logoss1">
              <img :src="userInfo.school_logo" alt="" v-if="userInfo">
              <img :src="schoolInfo.school_logo" alt="" v-else>
            </div>
            <div class="logoss">
              <img v-if="schoolInfo.type!=='1'" src="../../../static/img2/text.png" alt="">
              <img v-else  src="../../../static/img2/text2.png" alt="">
            </div>
          </div>
          <div class="nav-right" v-if='this.$cookies.get("token")'>
            <span style="cursor: pointer;" @click='goUrl("/ucenter/practiceList")' :style="{ color: activeColor }">训练项目</span>
            <span style="cursor: pointer;" @click='goUrl1("/ucenter/practices")' :style="{ color: activeColor1 }">成绩中心</span>
            <span style="cursor: pointer;" @click='goUrl3("/ucenter/grades")' :style="{ color: activeColor3 }">我的考试</span>
            <span style="cursor: pointer;" @click='goUrl4("/ucenter/homework")' :style="{ color: activeColor4 }">我的作业</span>
            <el-dropdown placement="bottom">
              <div class="el-dropdown-link">
                <img class="shoujid" :src="userInfo.head_img" alt="" v-if="userInfo.head_img">
                <img class="shoujid" src="../../../static/img2/tx.png" alt="" v-else>
                <span class="shoujjname" :title="userInfo.realname">{{ userInfo.realname||'注册用户'+userInfo.mobile}}</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><span @click="gorigthurl('/ucenter/teacherlist')">问答教师</span></el-dropdown-item>
                <el-dropdown-item><span @click='gomessage()'>我的消息</span></el-dropdown-item>
                <!-- <el-dropdown-item ><span @click="gorigthurl('/ucenter/notifications')">站内通知</span> </el-dropdown-item> -->
                <el-dropdown-item><span @click="gorigthurl('/ucenter/myInfo')">个人中心</span> </el-dropdown-item>
                <el-dropdown-item><span @click="gotopic()">主题风格</span> </el-dropdown-item>
                <el-dropdown-item><span @click="logout()">退出登录</span> </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="nav-right" v-else>
            <i class="el-icon-user"></i>
            <span @click="goLogin">登录</span>
          </div>
        </div>
      </el-header>
    </el-container>
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>

    </div>

    <div class="login-footer">
      <div class="shoujihrefs" style="margin-top:48px">
        <p class="hrefs"> Copyright：2019北京众绘虚拟现实技术研究院有限公司 版权所有</p>
        <!-- <p @click="gohref" class="hrefs">京ICP备18051304号-2</p> -->
        <p @click="gohref2" class="hrefss">京ICP备18051304号-4 <img src="../../../static/images/beian.png" style="width:16px; margin-left: 5px;margin-right: 5px; margin-top:10px" alt="" @click="gohref2" class="hrefs">京公网安备11011302003225号</p>
      </div>

    </div>
    <message :dialogVisiblemess="dialogVisiblemess" @lcclick="lcclick" />
    <el-drawer title="主题风格" :visible.sync="drawer" :direction="direction" :size="400" :before-close="handleClose">
      <div style="width: 100%;padding: 0 20px 20px 20px">
        <span style="font-size: 16px;font-weight: 600;">预设主题</span>
        <el-divider content-position="left"></el-divider>
        <img @click="setcolor(2)" style="width: 350px;cursor:pointer;" src="../../assets/img/heisexi.png" alt="">
        <img @click="setcolor(1)" style="width: 350px;margin-top: 20px;cursor:pointer;" src="../../assets/img/lusexi.png" alt="">
        <img @click="setcolor(3)" style="width: 350px;margin-top: 20px;cursor:pointer;" src="../../assets/img/baisexi.png" alt="">
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import { sethomegrade } from '../../restful/sethome.js'
import message from '../User/message.vue'
export default {
  components: { message },
  name: 'LuffyHeader',
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      headerList: [
        // {id: '1', name: 'Home', title: '首页'},
        // {id: '2', name: 'Course', title: '实验列表'},
        // {id:'3',name:'LightCourse',title:'轻课'},
        // {id:'4',name:'Micro',title:'学位课程'}
      ],
      isShow: false,
      show: false,
      userInfo: {},
      logout1: false,

      schoolInfo: this.$store.getters.getSchoolInfo,

      message: false,
      activeColor: '#009ad3',
      activeColor1: '',
      activeColor2: '',
      activeColor3: '',
      activeColor4: '',
      timer: '',
      timergriades: '',
      total: 0,
      totalgrades: 0,
      dialogVisiblemess: false,
    }
  },
  activated() {
    this.getUser()
    if (this.$route.path == '/ucenter/practiceList') {
      this.activeColor = '#009ad3'
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = ''
    }
    if (this.$route.path == '/ucenter/practices') {
      this.activeColor = ''
      this.activeColor1 = '#009ad3'
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = ''
    }
    if (this.$route.path == '/ucenter/myInfo') {
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = '#009ad3'
      this.activeColor3 = ''
      this.activeColor4 = ''
    }
    if (this.$route.path == '/ucenter/practiceDetail') {
      this.activeColor = ''
      this.activeColor1 = '#009ad3'
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = ''
    }
    if (this.$route.path == '/ucenter/grades') {
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = '#009ad3'
      this.activeColor4 = ''
    }
    if (this.$route.path == '/ucenter/homework') {
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = '#009ad3'
    }
  },
  mounted() {
    this.setRem()
    window.onresize = () => {
      return (() => {
        this.setRem()
      })()
    }
    this.sethomegrade()
    let colornumber = localStorage.getItem('stylecolor')
    this.setcolor(colornumber || 2)
  },
  methods: {
    setRem() {
      console.log('非移动设备')
      // 基准大小
      const baseSize = 100
      const basePc = baseSize / 1920 // 表示1920的设计图,使用100PX的默认值
      let vW = window.innerWidth // 当前窗口的宽度
      const vH = window.innerHeight // 当前窗口的高度
      // 非正常屏幕下的尺寸换算
      const dueH = (vW * 1080) / 1920
      if (vH < dueH) {
        // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        vW = (vH * 1920) / 1080
      }
      const rem = vW * basePc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + 'px'
    },
    // 主题
    gotopic() {
      this.drawer = true
    },
    // 关闭
    handleClose() {
      this.drawer = false
    },
    setcolor(e) {
      if (e == 1) {
        // 绿色
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg1', '#0c283a')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg2', '#0f334b')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg3', '#294d64')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--hed', '#091d2a')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--writing', '#fff')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--writing1', '#c0c4cc')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--inpborder', '#6edbff')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bottomtion', '#416175')
        localStorage.setItem('stylecolor', 1)
        this.handleClose()
      } else if (e == 2) {
        // 黑色
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg1', '#111217')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg2', '#191a1f')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg3', '#212129')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--hed', '#393a43')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--writing', '#fff')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--writing1', '#c0c4cc')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--inpborder', '#6edbff')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bottomtion', '#2f2f37')
        localStorage.setItem('stylecolor', 2)
        this.handleClose()
      } else if (e == 3) {
        // 白色
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg1', '#b1b1b2')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg2', '#cacacb')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bg3', '#e4e4e5')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--hed', '#989898')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--writing', '#333333')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--writing1', '#7f7f7f')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--inpborder', '#666666')
        document
          .getElementsByTagName('body')[0]
          .style.setProperty('--bottomtion', '#b2b2b2')
        localStorage.setItem('stylecolor', 3)
        this.handleClose()
      }
    },
    // 教师列表
    goteacher() {},
    // 取消
    lcclick() {
      this.dialogVisiblemess = false
    },
    // 我的消息
    gomessage() {
      // this.$router.push({
      //   path: '/ucenter/message',
      // })
      this.dialogVisiblemess = true
    },
    // 实时消息提示
    open3() {
      this.$notify.info({
        title: '消息',
        message: '有新的作业信息！',
      })
    },
    open4() {
      this.$notify({
        title: '消息',
        message: '有新的考试信息！',
        type: 'warning',
      })
    },
    // 获取作业数据实时数据
    gethome() {
      // console.log(12312312312)
      this.$http.gethomework().then((res) => {
        // console.log(this.total, res.data.list.total)
        // console.log('作业');
        if (res.code == 200) {
          if (this.total < res.data.list.total) {
            this.open3()
          }
          this.total = res.data.list.total
        } else {
          clearInterval(this.timer)
          clearInterval(this.timergriades)
        }
      })
    },
    // 获取考试数据实时数据
    getgriades() {
      // console.log(12312312312)
      this.$http.getgrades().then((res) => {
        // console.log(this.totalgrades, res.data.list.total)
        // console.log(res,'考试');
        if (res.code == 200) {
          if (this.totalgrades < res.data.list.total) {
            this.open4()
          }
          this.totalgrades = res.data.list.total
        } else {
          clearInterval(this.timer)
          clearInterval(this.timergriades)
        }
      })
    },
    // 定时调用作业
    setInt() {
      this.timer = setInterval(() => {
        if (this.$cookies.get('token')) {
          this.gethome()
        }
      }, 30000)
    },
    // 定时调用考试
    setIntgrades() {
      this.timergriades = setInterval(() => {
        if (this.$cookies.get('token')) {
          this.getgriades()
        }
      }, 30000)
    },
    // 获取作业初始数据
    gethomeinfor() {
      // console.log(12312322222222222222222222222222222)
      this.$http.gethomework().then((res) => {
        // console.log(res,'作业');
        if (res.code == 200) {
          this.total = res.data.list.total
          this.setInt()
        } else {
          clearInterval(this.timer)
          clearInterval(this.timergriades)
        }
      })
    },
    // 获取考试初始数据
    getgriadesinfor() {
      // console.log(12312322222222222222222222222222222237867)
      this.$http.getgrades().then((res) => {
        if (res.code == 200) {
          this.totalgrades = res.data.list.total
          this.setIntgrades()
        } else {
          clearInterval(this.timer)
          clearInterval(this.timergriades)
        }
      })
    },
    sethomegrade() {
      // console.log(234234234234234234);
      if (this.$cookies.get('token')) {
        // console.log('登陆成功后开始监听')
        this.gethomeinfor()
        this.getgriadesinfor()
        //用户登录完成之后 ，每次请求都携带请求头的token值，
      } else {
        // console.log('退出登录后清空定时器')
        clearInterval(this.timer)
        clearInterval(this.timergriades)
      }
    },
    head_screening() {
      // console.log(this.$route.path)
      if (this.$route.path == '/ucenter/practiceList') {
        this.activeColor = '#009ad3'
        this.activeColor1 = ''
        this.activeColor2 = ''
        this.activeColor3 = ''
        this.activeColor4 = ''
      }
      if (this.$route.path == '/ucenter/practices') {
        this.activeColor = ''
        this.activeColor1 = '#009ad3'
        this.activeColor2 = ''
        this.activeColor3 = ''
        this.activeColor4 = ''
      }
      if (this.$route.path == '/ucenter/myInfo') {
        this.activeColor = ''
        this.activeColor1 = ''
        this.activeColor2 = '#009ad3'
        this.activeColor3 = ''
        this.activeColor4 = ''
      }
      if (this.$route.path == '/ucenter/practiceDetail') {
        this.activeColor = ''
        this.activeColor1 = '#009ad3'
        this.activeColor2 = ''
        this.activeColor3 = ''
        this.activeColor4 = ''
      }
      if (this.$route.path == '/ucenter/grades') {
        this.activeColor = ''
        this.activeColor1 = ''
        this.activeColor2 = ''
        this.activeColor3 = '#009ad3'
        this.activeColor4 = ''
      }
      if (this.$route.path == '/ucenter/gradesinfor') {
        this.activeColor = ''
        this.activeColor1 = ''
        this.activeColor2 = ''
        this.activeColor3 = '#009ad3'
        this.activeColor4 = ''
      }
      if (this.$route.path == '/ucenter/homework') {
        this.activeColor = ''
        this.activeColor1 = ''
        this.activeColor2 = ''
        this.activeColor3 = ''
        this.activeColor4 = '#009ad3'
      }
      if (this.$route.path == '/ucenter/homeworkinfor') {
        this.activeColor = ''
        this.activeColor1 = ''
        this.activeColor2 = ''
        this.activeColor3 = ''
        this.activeColor4 = '#009ad3'
      }
    },
    gohref() {
      window.open('http://www.beian.miit.gov.cn')
    },
    gohref2() {
      window.open(
        'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302003225'
      )
    },
    gorigthurl(path) {
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = ''
      this.$router.push({
        path: path,
      })
    },
    goUrl(path) {
      // console.log(path)
      this.$router.push({
        path: path,
      })
      this.activeColor = '#009ad3'
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = ''
      this.head_screening()
    },
    goUrl1(path) {
      this.$router.push({
        path: path,
      })
      this.activeColor = ''
      this.activeColor1 = '#009ad3'
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = ''
      this.head_screening()
    },
    goUrl2(path) {
      this.$router.push({
        path: path,
      })
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = '#009ad3'
      this.activeColor3 = ''
      this.activeColor4 = ''
      this.head_screening()
    },
    goUrl3(path) {
      this.$router.push({
        path: path,
      })
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = '#009ad3'
      this.activeColor4 = ''
      this.head_screening()
    },
    goUrl4(path) {
      this.$router.push({
        path: path,
      })
      this.activeColor = ''
      this.activeColor1 = ''
      this.activeColor2 = ''
      this.activeColor3 = ''
      this.activeColor4 = '#009ad3'
      this.head_screening()
    },

    getMessage() {
      if (this.$cookies.get('token')) {
        this.$http
          .getMessage({ class_id: this.userInfo.class_id })
          .then((res) => {
            this.message = res.data.allCount > 0 ? true : false
          })
      }
    },

    logout() {
      this.$http.userLoginOut().then((res) => {
        this.$cookies.remove('token')
        this.$store.dispatch('SetUserInfo', null)
        this.$router.go(0)
        this.$router.push({
          name: 'Login',
        })
      })
    },
    changePassword() {
      this.$router.push({ name: 'changePassword' })
    },
    goLogin() {
      this.$router.push({ name: 'Login' })
    },
    getUser() {
      if (this.$cookies.get('token')) {
        this.$http.getUserInfo().then((res) => {
          this.userInfo = res.data
          // console.log(this.userInfo)
          if (res.data.head_img) {
            if (res.data.head_img.indexOf('http') !== -1) {
              this.userInfo.head_img = res.data.head_img
            } else {
              this.userInfo.head_img = this.GLOBAL.BASE_URL + res.data.head_img
            }
          } else {
            this.userInfo.head_img = ''
          }

          this.$store.commit('SetUserInfo', res.data)
          //   console.log(this.userInfo)
        })
      }
    },
  },
  created() {
    //
    // console.log(this.schoolInfo)
    // console.log(this.userInfo)
    this.getMessage()

    this.getUser()
    this.head_screening()
  },
}
</script>

<style lang="less" scoped>
.clickli:hover {
  background-color: #085da8;
}
.login-footer {
  width: 100%;
  height: 130px;
  /* line-height: 50px; */
  text-align: center;
  font-size: 16px;
  color: #4e546c;
  overflow: hidden;
  background-image: url(../../../static/img2/bottom.png);
}

.hrefs {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
}

.hrefss {
  cursor: pointer;
  color: #fff;
  font-size: 16px;
}
.el-header {
  /* background: #085da8; */
  color: white;
  padding: 0;
}

.header {
  background-image: url('../../../static/img2/top.png');
  background-size: 100% 100%;
  width: 100%;
  height: 0.9rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .nav-right {
    display: flex;
    width: 7rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    span {
      font-size: 0.18rem;
    }
    .shoujid {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 0.15rem;
    }
    .el-dropdown-link {
      font-size: 0.18rem;
      font-weight: 700;
      // height: 0.8rem;
      color: #fff;
      display: flex;
      align-items: center;
    }
  }
  .header-left {
    display: flex;
    align-items: center;
    .logoss {
      width: 3.3rem;
      img{
        height: auto;
        width: 3.3rem;
      }
    }

    .logoss1 {
      width: 3.3rem;
      img{
        height: auto;
        width: 2.8rem;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Common/LuffyHeader.vue